<ngx-loading-bar [color]="'#A389D2'" [includeSpinner]="false" [height]="'4px'"></ngx-loading-bar>
<app-loader *ngIf="show"></app-loader>
<router-outlet></router-outlet>